/**
 * Insights page — Phase 4 implementation.
 */

export default function Insights() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white">Portfolio Insights</h1>
      <div className="bg-gray-900 border border-gray-800 rounded-xl p-8 text-center">
        <p className="text-gray-400 mb-2">Insights module — Phase 4</p>
        <p className="text-sm text-gray-600">
          P&amp;L, allocation, FX exposure, dividend history, and UK CGT tax summary arrive in Phase 4.
        </p>
      </div>
    </div>
  );
}
